import { DataSyncRefNoBase } from '@/class/model/DataSyncRefNoBase'

export class PricePrePortLastMile extends DataSyncRefNoBase {
  constructor(data) {
    super(data)
    this.className = 'PricePrePortLastMile'
  }

  get quotationDetailUuid() {
    return this._data.quotationDetailUuid
  }

  set quotationDetailUuid(quotationDetailUuid) {
    this._data.quotationDetailUuid = quotationDetailUuid || ''
  }

  get priceNo() {
    return this._data.priceNo
  }

  set priceNo(priceNo) {
    this._data.priceNo = priceNo || ''
  }

  get priceMethod() {
    return this._data.priceMethod
  }

  set priceMethod(priceMethod) {
    this._data.priceMethod = priceMethod || 1
  }

  get branchLine() {
    return this._data.branchLine
  }

  set branchLine(branchLine) {
    this._data.branchLine = branchLine || 0
  }

  get pol() {
    return this._data.pol
  }

  set pol(pol) {
    this._data.pol = pol || ''
  }

  get portType() {
    return this._data.portType
  }

  set portType(portType) {
    this._data.portType = portType || 'seaport'
  }

  get wharf() {
    return this._data.wharf
  }

  set wharf(wharf) {
    this._data.wharf = wharf || ''
  }

  get supplier() {
    return this._data.supplier
  }

  set supplier(supplier) {
    this._data.supplier = supplier || 0
  }

  get beginDate() {
    return this._data.beginDate
  }

  set beginDate(beginDate) {
    this._data.beginDate = beginDate || null
  }

  get endDate() {
    return this._data.endDate
  }

  set endDate(endDate) {
    this._data.endDate = endDate || null
  }

  get status() {
    return this._data.status
  }

  set status(status) {
    this._data.status = status || 1
  }

  get remarks() {
    return this._data.remarks
  }

  set remarks(remarks) {
    this._data.remarks = remarks || ''
  }

  get type() {
    return this._data.type
  }

  set type(type) {
    this._data.type = type || 0
  }

  get pod() {
    return this._data.pod
  }

  set pod(pod) {
    this._data.pod = pod || ''
  }

  get deliveryAddressType() {
    return this._data.deliveryAddressType
  }

  set deliveryAddressType(deliveryAddressType) {
    this._data.deliveryAddressType = deliveryAddressType || 1
  }

  get postalCode() {
    return this._data.postalCode
  }

  set postalCode(postalCode) {
    this._data.postalCode = postalCode || ''
  }

  get address() {
    return this._data.address
  }

  set address(address) {
    this._data.address = address || ''
  }

  get detailAddress() {
    return this._data.detailAddress
  }

  set detailAddress(detailAddress) {
    this._data.detailAddress = detailAddress || ''
  }

  get warehouseCode() {
    return this._data.warehouseCode
  }

  set warehouseCode(warehouseCode) {
    this._data.warehouseCode = warehouseCode || ''
  }

  get agentName() {
    return this._data.agentName
  }

  set agentName(agentName) {
    this._data.agentName = agentName || 0
  }

  get byEqSizeChargingItems() {
    return this._data.byEqSizeChargingItems
  }
  set byEqSizeChargingItems(byEqSizeChargingItems) {
    this._data.byEqSizeChargingItems = byEqSizeChargingItems || []
  }

  get notByEqSizeChargingItems() {
    return this._data.notByEqSizeChargingItems
  }
  set notByEqSizeChargingItems(notByEqSizeChargingItems) {
    this._data.notByEqSizeChargingItems = notByEqSizeChargingItems || []
  }

  get delChargingItemUuids() {
    return this._data.delChargingItemUuids
  }
  set delChargingItemUuids(delChargingItemUuids) {
    this._data.delChargingItemUuids = delChargingItemUuids || []
  }

  get podList() {
    return this._data.podList
  }
  set podList(podList) {
    this._data.podList = podList || []
  }

  get priceRegions() {
    return this._data.priceRegions
  }
  set priceRegions(priceRegions) {
    if (!priceRegions || !Array.isArray(priceRegions)) {
      this._data.priceRegions = [{
        country: 'CN',
        province: '',
        city: '',
        districts: '',
        townUuid: '',
        deliveryAddressType: 1,
        postalCode: '',
        address: '',
        warehouseCode: ''
      }]
    } else {
      this._data.priceRegions = priceRegions.map(region => ({
        country: region.country || 'CN',
        province: region.province || '',
        city: region.city || '',
        districts: region.districts || '',
        townUuid: region.townUuid || '',
        ...region
      }))
    }
  }

  get delPriceRegionsUuids() {
    return this._data.delPriceRegionsUuids
  }
  set delPriceRegionsUuids(delPriceRegionsUuids) {
    this._data.delPriceRegionsUuids = delPriceRegionsUuids || []
  }
}
